export default "__VITE_ASSET__BDSxsVko__"